import { hotjar } from "react-hotjar";
import posthog from "posthog-js";
import { cvgTrack } from "Root/utils/tracking";
const hjid = 1118618;
const hjsv = 6;
hotjar.initialize(hjid, hjsv);
export const pageView = (path) => {
    if (hotjar.initialized()) {
        hotjar.stateChange(path);
    }
    posthog?.capture("$pageview");
    cvgTrack({
        eventName: "$page_load",
        properties: { $url: window.location.href },
    });
};
export const hotjarEvent = (event) => {
    if (hotjar.initialized()) {
        hotjar.event(event);
    }
};
